// extracted by mini-css-extract-plugin
module.exports = {"out_cont":"mangaButton_out_cont__YsS_3","fadeInUp":"mangaButton_fadeInUp__n3DGH","buttonCont":"mangaButton_buttonCont__84u6J"};